export enum Messages {
    Bind = "StubBind",
    Unbind = "StubUnbind", // string bindingId
    Invoke = "StubInvoke",
    EventBinding = "StubEventBinding",
    EventEmit = "StubEventEmit"
}